export default __webpack_public_path__ + "assets/images/b6bfb63b71403f4590329174b8c6600c.svg";